import React, { useEffect, useState } from "react";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import {
  LinearProgress,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { AddButton } from "../Button/AddButton";
import DataTable from "./data-table";
import { useDispatch } from "react-redux";
import { setOpen } from "../../Redux/ModalReducer";
import DeleteModal from "./DeleteModal";
import {Can} from "../Can";

export const CategoryTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const dispatch = useDispatch();
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleShow = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };
  const getData = async () => {
    setIsLoading(true);

    const { response, message } = await Helper.Get({
      url: `${api_Routes.Categories.View}?per_page=${rowsPerPage}&page=${
        currentPage + 1
      }`,
      hasToken: true,
    });
    if (response) {
      setData(response);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (shouldRefresh) {
      setCurrentPage(0);
      setShouldRefresh(false);
    } else getData();
  }, [currentPage, rowsPerPage, shouldRefresh]);

  return (
    <div>
      {/* Filter Section */}

      <Can I="store" a="categories">
      <div className="flex justify-between items-center mb-3">
        <AddButton to="/Categories/Add" label="Add Category" />
      </div>
      </Can>
      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable
              data={data?.data}
              setSelectedId={setSelectedId}
              handleShow={handleShow}
            />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data.meta.total}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
          <DeleteModal
            show={show}
            handleClose={handleClose}
            selectedId={selectedId}
            setShouldRefresh={setShouldRefresh}
          />
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
